import { message } from 'antd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { api } from '../../../api'
import Agreement from '../../../components/common/Agreement/agreement'
import Button from '../../../components/common/Button/button'
import ForgotPassButton from '../../../components/common/ForgotPassButton/forgotPassButton'
import Input from '../../../components/common/Input'
import {
  callbackGetCompany,
  getError,
  getReadStatuses,
  redirectToUnfilledPage,
} from '../../../helpers/helpers'
import { useStore } from '../../../mobx-store/context'
import AgreementPopup from '../Agreement/agreement'
import { Bottom } from '../authForm.style'
import { HookForm } from './form.style'

const Form = observer(({ login }) => {
  const history = useHistory()
  const store = useStore()

  const checkForRegisterData =
    store.registerData.email && store.registerData.password

  const { control, handleSubmit, errors, setError, watch, reset } = useForm({
    mode:
      history.location.state && checkForRegisterData ? 'onChange' : 'onSubmit',
  })
  const [cookies, setCookie, removeCookie] = useCookies(['pbm_token', 'userId'])
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  const watchAllFields = watch()

  useEffect(() => {
    const locationHash = history.location.hash
    const locationState = history.location.state
    reset(store.registerData)

    if (locationHash === '#popup') setVisible(true)

    if (!checkForRegisterData) return

    if (locationState) {
      for (let key in locationState) {
        setError(key, {
          type: 'manual',
        })
      }
    }
  }, [])

  const logIn = (data) => {
    const { email, password } = data
    setLoading(true)
    removeCookie('pbm_token')
    store.reset()
    api(
      '/token/',
      {
        email,
        password,
        username: email,
      },
      'POST',
      true
    )
      .then((data) => {
        if (data.errors) {
          message.error(getError(data))
          return setLoading(false)
        }

        setCookie('pbm_token', data.access, { path: '/' })

        getReadStatuses()

        store.getCompany(() => {
          store.getUser(() => {
            store.getResourceTariffInfo(() => {
              if (
                store.company[0].started_from_resource &&
                !store.company[0].have_access_to_tracking &&
                store.company[0].have_access_to_resource
              ) {
                history.push('/resource/table/jurisdictions')
              } else {
                redirectToUnfilledPage(history, store, true)
              }
              localStorage.removeItem('legislativeToGo')
              localStorage.removeItem('assignee')
              setLoading(false)
            })
          })
        })
        store.loadSelect('companyOptions', () =>
          store.getSelectedJurisdictions()
        )
      })
      .catch((err) => console.log(err))
  }

  const handleRegister = (values) => {
    store.setRegisterData('email', values.email)
    store.setRegisterData('password', values.password)

    removeCookie('pbm_token')
    setVisible(true)
  }

  return (
    <HookForm onSubmit={handleSubmit(login ? logIn : handleRegister)}>
      {watchAllFields && (
        <>
          <Input
            type={'email'}
            control={control}
            placeholder={'E-Mail'}
            name={'email'}
            label={'Email Address'}
            transparent
            validation={{
              required: true,
            }}
            style={{ marginBottom: !errors.email && '.5em' }}
            error={errors.email && 'Enter valid email'}
          />
          <Input
            type={'password'}
            control={control}
            placeholder={'Password'}
            name={'password'}
            label={login ? 'Password' : 'Create Password'}
            transparent
            validation={{
              required: true,
              minLength: 8,
            }}
            error={
              errors.password && 'Enter valid password. Min length - 8 symbols'
            }
          />
        </>
      )}

      {!login && (
        <Agreement
          checked={checked}
          onChange={(checked) => setChecked(checked)}
        />
      )}
      {!login && visible && (
        <AgreementPopup
          onClick={() => {
            setVisible(false)
          }}
          setError={setError}
        />
      )}
      <Bottom style={{ justifyContent: 'center' }}>
        <Button
          text={login ? 'Sign In ' : 'Sign Up'}
          type={'main'}
          loading={loading}
          disabled={!login && !checked}
          style={{ width: '15.625em', marginBottom: '.5em' }}
        />
        {login && <ForgotPassButton />}
      </Bottom>
    </HookForm>
  )
})

export default Form

export const register = async (
  data,
  setLoading,
  setCookie,
  store,
  history,
  removeCookie,
  ga4React
) => {
  removeCookie('pbm_token')
  setLoading(true)
  const { email, password } = data
  api(
    '/users/',
    {
      email,
      password,
      username: email,
      started_from_resource: store.started_from_resource,
    },
    'POST',
    true
  )
    .then((data) => {
      if (data.errors) {
        removeCookie('pbm_token')
        store.reset()
        store.setSingleValue('user', data)
        message.error(getError(data))
        setLoading(false)
      } else {
        removeCookie('pbm_token')
        return api(
          '/token/',
          {
            email,
            password,
            username: email,
          },
          'POST',
          true
        )
      }
    })
    .then((data) => {
      if (data)
        if (!data?.errors) {
          setCookie('pbm_token', data.access, { path: '/' })
          ga4React?.gtag('event', 'registration')
          return api('/companies/', {}, 'GET')
        } else {
          message.error(getError(data))
        }
    })
    .then((data) => {
      if (data)
        if (!data?.errors) {
          callbackGetCompany(data, setLoading, store, history)
          store.reset()
        }
    })
    .catch((err) => {
      setLoading(false)
    })
}
